import React from "react";
import Avatar from "@material-ui/core/Avatar";
import "./style.less";

export class AvatarIconComponent extends React.Component {
  render() {
    return (
      <Avatar
        style={{
          backgroundColor: this.props.backgroundColor
        }}
        className={this.props.className}
      >
        {" "}
        {this.props.children}{" "}
      </Avatar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/icon_components/index.js